import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'hash',
	routes: [
		{
			path: '/',
			name: 'Home',
			component: (resolve) => require(['@/views/Home.vue'], resolve),
		},
		{
			path: '/Privacy',
			name: 'Privacy',
			component: (resolve) => require(['@/views/Privacy.vue'], resolve),
		},
		{
			path: '/Terms',
			name: 'Terms',
			component: (resolve) => require(['@/views/Terms.vue'], resolve),
		},
		{
			path: '/delete',
			name: 'delete',
			component: (resolve) => require(['@/views/delete.vue'], resolve),
		},
	],
})
